const cityAndState = city => {
  let isAValidCityWithState = isAValidCity(city) && haveAState(city);
  return isAValidCityWithState
    ? `${city.display_name}/${city.state.code.toUpperCase()}`
    : "";
};

const isAValidCity = city => city.id && city.display_name;
const haveAState = city => city.state && city.state.id && city.state.code;

export default {
  filters: {
    cityAndState
  },
  methods: {
    cityAndState
  }
};



// WEBPACK FOOTER //
// ./src/mixins/cityMixin.js